import type {
  CampaignTemplateCustomStyle,
  ClubCampaignPrefectureGroup,
} from "@components/CampaignTemplate";
import CampaignTemplate from "@components/CampaignTemplate";
import { CommonHead } from "@components/CommonHead";
import CommonLayout from "@components/CommonLayout";
import { isTypeProps, queryForSSP } from "@libs/apolloClient";
import { paths } from "@libs/paths";
import { Cerezo202203_RawShopsDocument as RawShopsDocument } from "./__generated__/queries";
import styles from "./index.module.css";
import type { Cerezo202203_RawShopsQueryResult as RawShopsQueryResult } from "./__generated__/queries";
import type { ApolloError } from "@apollo/client";
import type { GetServerSideProps, NextPage } from "next";

const isProduction = process.env.DEPLOY_ENV === "production";
const PREFECTURES: Array<ClubCampaignPrefectureGroup> = [
  {
    prefecture: "大阪",
    shopUuids: isProduction
      ? [
          "H0Opp8rMbNu3",
          "rgPGOPEagIko",
          "oiWy4KSMsiZf",
          "ZDRUpOzqQFyV",
          "PMF38QJedGyM",
        ]
      : [
          "UuidUuidUuid",
          "UuidUuidUuid",
          "UuidUuidUuid",
          "UuidUuidUuid",
          "UuidUuidUuid",
        ],
  },
  {
    prefecture: "東京",
    shopUuids: isProduction
      ? ["q095K9yUz7ee", "YGFlPRzaagjM"]
      : ["UuidUuidUuid", "UuidUuidUuid"],
  },
];

type Cerezo202203PageProps = {
  data?: RawShopsQueryResult["data"];
  prefectures?: Array<ClubCampaignPrefectureGroup>;
  error?: ApolloError;
};

const Cerezo202203: NextPage<Cerezo202203PageProps> = ({
  data,
  prefectures,
}) => {
  return (
    <CommonLayout hasFooter noModal>
      <CommonHead
        title={"セレッソ大阪をお店で応援！セレッソ大阪を観戦できるスポーツバー"}
        description={
          "明治安田J1リーグのセレッソ大阪戦を応援できる梅田、心斎橋、阿倍野、住吉、恵比寿、八重洲などのDAZN公式契約スポーツバーをご紹介。応援ドリンクも販売中。スポーツバー探し、予約はFanstaで。"
        }
        ogUrl={paths.campaignCerezo202203}
        ogImage={`${process.env.APP_HOST}/img/campaign/cerezo-202203/ogp.png`}
        canonicalUrl={paths.campaignCerezo202203}
      />
      <CampaignTemplate
        teamName="セレッソ大阪"
        slug="cerezo-202203"
        leagueName="明治安田J1リーグ"
        teamIds={[12]}
        colorText="ピンク"
        prefectures={prefectures}
        shopData={data?.rawShops}
        customStyle={styles as CampaignTemplateCustomStyle}
        sportGenreSlug={"soccer"}
        teamSlug={"cerezo"}
        specialEventAreaHidden
      />
    </CommonLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async () => {
  // PREFECTURESに定義されたデータからUUIDを抽出する。
  const shopUuids = PREFECTURES.map((p) => p.shopUuids);
  const flattenShopUuids = ([] as Array<string>).concat(...shopUuids);

  // 該当する店舗を検索する。
  const pageProps = await queryForSSP({
    query: RawShopsDocument,
    variables: {
      uuids: flattenShopUuids,
    },
  });

  if (!isTypeProps(pageProps)) {
    return {
      props: {},
    };
  }

  return {
    props: {
      ...pageProps.props,
      prefectures: PREFECTURES,
    },
  };
};

export default Cerezo202203;
